/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Rental_FrequencyInputs */

const en_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rental Frequency`)
};

const es_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frecuencia de alquiler`)
};

const fr_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence de location`)
};

const de_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mietintervall`)
};

const ja_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レンタルの頻度`)
};

const zh_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`租赁频率`)
};

const ar_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وتيرة الإيجار`)
};

const id_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frekuensi Sewa`)
};

const it_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza di Affitto`)
};

const ru_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частота аренды`)
};

const pt_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequência de Aluguel`)
};

const ko_field_rental_frequency = /** @type {(inputs: Field_Rental_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임대 단위`)
};

/**
* | output |
* | --- |
* | "Rental Frequency" |
*
* @param {Field_Rental_FrequencyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_rental_frequency = /** @type {((inputs?: Field_Rental_FrequencyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Rental_FrequencyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_rental_frequency(inputs)
	if (locale === "es") return es_field_rental_frequency(inputs)
	if (locale === "fr") return fr_field_rental_frequency(inputs)
	if (locale === "de") return de_field_rental_frequency(inputs)
	if (locale === "ja") return ja_field_rental_frequency(inputs)
	if (locale === "zh") return zh_field_rental_frequency(inputs)
	if (locale === "ar") return ar_field_rental_frequency(inputs)
	if (locale === "id") return id_field_rental_frequency(inputs)
	if (locale === "it") return it_field_rental_frequency(inputs)
	if (locale === "ru") return ru_field_rental_frequency(inputs)
	if (locale === "pt") return pt_field_rental_frequency(inputs)
	return ko_field_rental_frequency(inputs)
});